// The filters in force, one chip per column, each removable, with Clear all. This is how a
// filter on a column scrolled off-screen is seen, and how the tiles show what is in force. The
// tracker renders it only when there is a filter, so the strip never sits empty above a table.

import Icon from '../ui/Icon.jsx';
import { BLANK, BLANK_LABEL } from './FilterPopover.jsx';

export default function FilterChips({ columns, query, onFilter, onClear }) {
  const labelOf = (key) => columns.find((column) => column.key === key)?.label ?? key;

  return (
    <div className="filter-chips" role="group" aria-label="Filters in force">
      {Object.entries(query.filters).map(([key, values]) => (
        <span key={key} className="chip">
          <strong>{labelOf(key)}:</strong>{' '}
          {values.map((value) => (value === BLANK ? BLANK_LABEL : value)).join(', ')}
          <button type="button" className="icon-button" aria-label={`Remove ${labelOf(key)} filter`}
                  onClick={() => onFilter(key, [])}>
            <Icon name="close" />
          </button>
        </span>
      ))}
      <button type="button" className="link" onClick={onClear}>Clear all</button>
    </div>
  );
}
